import React from "react";

// QuestionIcon and AnswerIcon used to live in Enrolment/Learning/Icons.tsx
// alongside the chapter/resource/lives navigation icons. The lesson redesign
// removed the whole Learning directory, and these two were the only exports the
// interactive course still used -- so they moved here, next to their callers,
// rather than keeping a dead file alive for them.

export const QuestionIcon = () => (
  <svg
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="26" cy="26" r="26" fill="#4BA0DD" />
    <path
      d="M33.192 35.42C32.796 36.1973 32.334 36.8353 31.806 37.334L31.564 37.422C28.836 36.41 26.4233 35.0093 24.326 33.22H23.864C21.8693 33.22 20.3293 32.604 19.244 31.372C18.1587 30.1253 17.616 28.3653 17.616 26.092C17.616 23.7013 18.1953 21.8607 19.354 20.57C20.5273 19.2793 22.1847 18.634 24.326 18.634C26.3207 18.634 27.8533 19.2427 28.924 20.46C30.0093 21.6627 30.552 23.3933 30.552 25.652C30.552 27.3533 30.244 28.798 29.628 29.986C29.012 31.174 28.132 32.0393 26.988 32.582C28.9093 33.7553 30.9407 34.5987 33.082 35.112L33.192 35.42ZM20.718 25.762C20.718 27.61 20.982 28.93 21.51 29.722C22.038 30.514 22.9033 30.91 24.106 30.91C25.25 30.91 26.086 30.536 26.614 29.788C27.1567 29.04 27.428 27.83 27.428 26.158C27.428 24.3247 27.164 23.0193 26.636 22.242C26.108 21.45 25.2427 21.054 24.04 21.054C22.8667 21.054 22.016 21.4207 21.488 22.154C20.9747 22.8873 20.718 24.09 20.718 25.762Z"
      fill="white"
    />
  </svg>
);

export const AnswerIcon = () => (
  <svg
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="26" cy="26" r="26" fill="#392D40" />
    <path
      d="M30.848 33H27.812L27.46 31.152L27.086 29.832L24.314 29.766L21.872 29.832L21.498 30.998L21.124 33H18.176L22.972 18.832H26.514L30.848 33ZM26.448 27.522L24.776 21.626H24.578L22.642 27.522L24.534 27.566L26.448 27.522Z"
      fill="white"
    />
  </svg>
);
